import BaseButton from "../primitive/BaseButton";
import { MessageObjectTypes, IMessage } from "../../types";

/**
 * Preview of a shared Needbox inside a chat bubble.
 *
 * The "مشاهده نیدباکس" button relies on the global `data-button-action` click
 * handler owned by the panel bundle (`dusco/src/entries/global/click-handler-hook.js`),
 * which dispatches `action-show-needbox-users` on the shared event bus.
 * `dusco/src/entries/needbox/hook-needbox.js` listens for that event and opens the popup,
 * so the needbox shows up automatically without any chat-specific glue code.
 */
export function NeedboxMessage({ message }: { message: IMessage }) {
    const { object_id, needbox_product_name, needbox_image, text } = message;

    if (!object_id) {
        // The needbox was deleted in the meantime — fall back to the plain caption.
        return text ? <div className="text-sm whitespace-pre-wrap">{text}</div> : null;
    }


    return (
        <div className="flex flex-col gap-2 w-56" style={{ direction: "rtl" }}>
            <div className="flex flex-col gap-2">
                {Boolean(needbox_image) && (
                    <img
                        className="max-w-full max-h-40 w-full object-cover rounded-lg bg-neutral-30"
                        src={needbox_image ?? undefined}
                        alt={needbox_product_name ?? "needbox"}
                    />
                )}
                {Boolean(needbox_product_name) && (
                    <div className="text-sm font-medium truncate font-bold" title={needbox_product_name ?? undefined}>
                        {needbox_product_name}
                    </div>
                )}
            </div>

            <div className="text-sm whitespace-pre-wrap">
                <div>
                    درخواست جدید تو حوزه شما 👀
                </div>
                من دنبال «{needbox_product_name}» می‌گردم — اگه این محصول رو داری می‌تونی همین الان پیشنهاد بدی.
            </div>

            <BaseButton
                mode="action-message"
                smaller
                data-button-action="show-needbox"
                data-needbox-id={object_id}
                data-context="explore"
            >
                مشاهده نیدباکس
            </BaseButton>
        </div>
    );
}

/**
 * Renders the right preview for the object attached to an OBJECT message.
 * Falls back to the message text for object types that are not supported yet.
 */
export function ObjectMessage({ message }: { message: IMessage }) {
    if (message.object_type === MessageObjectTypes.NEEDBOX) {
        return <NeedboxMessage message={message} />;
    }

    return message.text ? <div className="text-sm whitespace-pre-wrap">{message.text}</div> : null;
}
